import React, { useEffect, useState} from 'react';
import DatePicker from 'react-datepicker';
import { isBefore, differenceInDays, addDays } from 'date-fns';
import { Box, InputAdornment, TextField, Typography, useTheme, Alert } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import FechaFunction from '../../function/FechaFunction';

const DateRange = ({minDate,onChange,isDisabled,initianDate,isClearable,maxDays}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [startDate, setStartDate] = useState(initianDate?.startDate);
    const [endDate, setEndDate] = useState(initianDate?.endDate);
    const [errorMaxDays, setErrorMaxDays] = useState(false);
    
    const CustomInput = React.forwardRef(
        ({value: valueField, onClick}, ref) => (
            <TextField
                onClick={onClick}
                value={valueField}
                ref={ref}
                readOnly
                autoComplete='off'
                focused
                InputProps={{
                    startAdornment: (
                        <Box sx={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems: 'center',alignContent:'center', backgroundColor: isDarkMode ? '#2d3a52' : '#b1cfff',height:{xs:41,xl:42},width:50,marginLeft:-1.7,borderTopLeftRadius:4,borderBottomLeftRadius:5}}>
                            <InputAdornment position="start">
                                <CalendarMonthIcon sx={{color: isDarkMode ? '#64B5F6' : '#0364ff',marginLeft:1}} />
                            </InputAdornment>
                        </Box>
                    ),
                }}
                sx={{
                    '& fieldset': {
                    },
                    '& .MuiOutlinedInput-root': {
                        '&.Mui-focused fieldset': {
                        borderBottomRightRadius: 10,
                        borderTopRightRadius:10,
                        borderColor: isDarkMode ? '#3d4a62' : '#b1cfff',
                        },
                    },
                    '& input': {
                        color: isDarkMode ? '#e0e0e0' : '#2c3e50',
                        background: isDarkMode ? '#1F2A40' : '#fff',
                        borderBottomRightRadius: 10,
                        borderTopRightRadius:10,
                        height:10,
                        textAlign: 'center',
                        fontWeight: 'bold'
                    },
                }}
            />
        )
    );
    
    const onChangeData = (destino,fecha) =>{
        if(destino === 'start'){
            const anterior = isBefore(endDate,fecha)
            setStartDate(fecha)
            
            // Validar rango máximo si existe
            if(maxDays && endDate){
                const diasDiferencia = differenceInDays(endDate, fecha)
                if(diasDiferencia > maxDays){
                    // Ajustar endDate al máximo permitido
                    const newEndDate = addDays(fecha, maxDays)
                    setEndDate(newEndDate)
                    setErrorMaxDays(true)
                    setTimeout(() => setErrorMaxDays(false), 3000)
                    onChange({
                        startDate: fecha,
                        endDate: newEndDate
                    })
                    return
                }
            }
            
            if(anterior){
                setEndDate(fecha)
                onChange({
                    startDate: fecha,
                    endDate: fecha
                })
            }else{
                onChange({
                    startDate: fecha,
                    endDate
                })
            }
        }else{
            // Validar rango máximo si existe
            if(maxDays && startDate){
                const diasDiferencia = differenceInDays(fecha, startDate)
                if(diasDiferencia > maxDays){
                    setErrorMaxDays(true)
                    setTimeout(() => setErrorMaxDays(false), 3000)
                    return
                }
            }
            
            setEndDate(fecha)
            onChange({
                startDate,
                endDate: fecha
            })
        }
    }
    
    useEffect(() => {
        if(initianDate?.startDate){
            setStartDate( FechaFunction.parse(initianDate.startDate))
        }
        if(initianDate?.endDate){
            setEndDate( FechaFunction.parse(initianDate.endDate))
        }
    }, [initianDate])
    
    const maxDateEnd = maxDays && startDate ? addDays(startDate, maxDays) : undefined;
    
    return (
        <Box>
            <Box display='flex'>
                <Box display='block'>
                    <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#2c3e50',fontWeight: 'bold'}}>Desde</Typography>
                    <DatePicker
                        selected={startDate}
                        onChange={(date) => onChangeData('start',date)}
                        dateFormat="P"
                        disabled={isDisabled}
                        customInput={<CustomInput />}
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                        minDate={minDate || new Date()}
                        popperPlacement="auto"
                        isClearable={isClearable && startDate}
                    />
                </Box>
                <Box display='block' ml={2}>
                    <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#2c3e50',fontWeight: 'bold'}}>Hasta</Typography>
                    <DatePicker
                        selected={endDate}
                        onChange={(date) => onChangeData('end',date)}
                        dateFormat="P"
                        disabled={isDisabled || !startDate}
                        customInput={<CustomInput />}
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                        maxDate={maxDateEnd}
                        popperPlacement="auto"
                        isClearable={isClearable && endDate}
                    />
                </Box>
            </Box>
            {errorMaxDays && maxDays && (
                <Alert severity="warning" sx={{ mt: 1, fontSize: 12 }}>
                    El rango máximo permitido es de {maxDays} días
                </Alert>
            )}
        </Box>
    );
}

export default DateRange;
